export const formatGBP = (value: number | string | null | undefined) => {
  const amount = typeof value === 'string' ? Number(value) : (value ?? 0);
  const safe = Number.isFinite(amount as number) ? (amount as number) : 0;
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(safe);
};
